import axiosClient from "../../../../system/helpers/axiosConfig";

export const postBrandInfo = (params) => {
    return axiosClient
        .post(`api/admin/brands/update`, params)
        .then((r) => r.data.data);
};